var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dado && _vm.dado.id_imposto != 100 && !_vm.dado.texto_inaplicabilidade)?_c('div',{staticClass:"separador"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }